import { RECORD_PRIVACY } from '@shared/constants';
import type { IMoodRecord, IMoodRecordDraft } from '@shared/types';
import { NotLoggedInError } from '@/components/ErrorBoundary/types';
import * as storage from './moodRecordDraftStorage';

/**
 * Creates a draft for a mood record.
 * @param arg0 - The owner ID or mood record.
 * @returns A draft for a mood record.
 * If a string is provided, a new draft is created for a new mood record.
 * If a mood record is provided, a draft is created for the existing mood record.
 */
export const createMoodRecordDraft = (
  ownerUid: string,
  moodRecord?: IMoodRecord
): IMoodRecordDraft => {
  if (!ownerUid || typeof ownerUid !== 'string' || ownerUid.trim() === '') {
    console.log(
      '\x1b[31m%s\x1b[0m',
      'in createMoodRecordDraft() -> this is the ownerUid:',
      ownerUid
    );
    throw new NotLoggedInError();
  }
  if (!moodRecord) {
    // Build a new draft for a new mood record.
    const today = new Date().toISOString().slice(0, 10);
    return {
      id: storage.buildDraftId(ownerUid, today),
      ownerId: ownerUid,
      moodDate: today,
      sharedWithFriends: [],
      privacy: RECORD_PRIVACY.PRIVATE,
      triggers: [],
    };
  } else {
    // Build a draft for an existing mood record.
    const draft: IMoodRecordDraft = {
      id: storage.buildDraftId(ownerUid, moodRecord.mood_date),
      // emotions: moodRecord.label_emotions,
      imageContentType: moodRecord.image_contentType,
      imagePath: moodRecord.image_key,
      mood: moodRecord.label_mood,
      moodDate: moodRecord.mood_date,
      note: moodRecord.note,
      ownerId: ownerUid,
      privacy: moodRecord.privacy,
      // sharedWithFriends: moodRecord.shared_with_friends,
      // triggers: moodRecord.label_triggers,
    };
    return draft;
  }
};
